import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationBureauMappingCreateRequest, ApplicationBureauMappingCreateResponse, ApplicationBureauMappingDeleteRequest, ApplicationBureauMappingReadAllResponse, ApplicationBureauMappingReadByApplicationIdRequest, ApplicationBureauMappingReadByApplicationIdResponse, ApplicationBureauMappingReadByBureauSummaryIdRequest, ApplicationBureauMappingReadByBureauSummaryIdResponse, ApplicationBureauMappingReadByIdRequest, ApplicationBureauMappingReadByIdResponse, ApplicationBureauMappingUpdateRequest, ApplicationBureauMappingUpdateResponse, CreditBureauReportCreateRequest, CreditBureauReportCreateResponse, CreditBureauReportDeleteRequest, CreditBureauReportReadAllResponse, CreditBureauReportReadByIdRequest, CreditBureauReportReadByIdResponse, CreditBureauReportReadByUserIdRequest, CreditBureauReportReadByUserIdResponse, CreditBureauReportUIRequest, CreditBureauReportUpdateRequest, CreditBureauReportUpdateResponse, CreditBureauSummaryCreateRequest, CreditBureauSummaryCreateResponse, CreditBureauSummaryDeleteRequest, CreditBureauSummaryReadAllResponse, CreditBureauSummaryReadByBureauReportIdRequest, CreditBureauSummaryReadByBureauReportIdResponse, CreditBureauSummaryReadByIdRequest, CreditBureauSummaryReadByIdResponse, CreditBureauSummaryReadByUserIdRequest, CreditBureauSummaryReadByUserIdResponse, CreditBureauSummaryUpdateRequest, CreditBureauSummaryUpdateResponse, DocumentAddressCreateRequest, DocumentAddressCreateResponse, DocumentAddressDeleteRequest, DocumentAddressReadAllResponse, DocumentAddressReadByIdRequest, DocumentAddressReadByIdResponse, DocumentAddressReadByUserIdRequest, DocumentAddressReadByUserIdResponse, DocumentAddressUpdateRequest, DocumentAddressUpdateResponse, FraudDetectionRequest, FraudDetectionResponse} from "./credit-engine.interface";
import { ApplicationBureauMappingCreate, ApplicationBureauMappingDelete, ApplicationBureauMappingReadAll, ApplicationBureauMappingReadByApplicationId, ApplicationBureauMappingReadByBureauSummaryId, ApplicationBureauMappingReadById, ApplicationBureauMappingUpdate, CreditBureauReportCreate, CreditBureauReportDelete, CreditBureauReportReadAll, CreditBureauReportReadById, CreditBureauReportReadByUserId, CreditBureauReportUpdate, CreditBureauSummaryCreate, CreditBureauSummaryDelete, CreditBureauSummaryReadAll, CreditBureauSummaryReadByBureauReportId, CreditBureauSummaryReadById, CreditBureauSummaryReadByUserId, CreditBureauSummaryUpdate, DocumentAddressCreate, DocumentAddressDelete, DocumentAddressReadAll, DocumentAddressReadById, DocumentAddressReadByUserId, DocumentAddressUpdate, FraudDetection, GenerateBureauReportUI} from "src/app/GlobalVariable";

@Injectable({ providedIn: 'root' })

export class CreditEngineServices {
    http = inject(HttpClient)

    // *** DocumentAddress Services *** //

    // Create
    DocumentAddress_Create(requestPayload: DocumentAddressCreateRequest): Observable<DocumentAddressCreateResponse> {
        return this.http.post<DocumentAddressCreateResponse>(DocumentAddressCreate, requestPayload);
    }

    // Update
    DocumentAddress_Update(requestPayload: DocumentAddressUpdateRequest): Observable<DocumentAddressUpdateResponse> {
        return this.http.post<DocumentAddressUpdateResponse>(DocumentAddressUpdate, requestPayload);
    }

    // Delete
    DocumentAddress_Delete(requestPayload: DocumentAddressDeleteRequest): Observable<void> {
        return this.http.post<void>(DocumentAddressDelete, requestPayload);
    }

    // ReadAll
    DocumentAddress_ReadAll(): Observable<DocumentAddressReadAllResponse> {
        return this.http.get<DocumentAddressReadAllResponse>(DocumentAddressReadAll);
    }

    // ReadById
    DocumentAddress_ReadById(requestPayload: DocumentAddressReadByIdRequest): Observable<DocumentAddressReadByIdResponse> {
        return this.http.post<DocumentAddressReadByIdResponse>(DocumentAddressReadById, requestPayload);
    }

    // ReadByUserId
    DocumentAddress_ReadByUserId(requestPayload: DocumentAddressReadByUserIdRequest): Observable<DocumentAddressReadByUserIdResponse> {
        return this.http.post<DocumentAddressReadByUserIdResponse>(DocumentAddressReadByUserId, requestPayload);
    }

    // *** CreditBureauReport Services *** //

    // Create
    CreditBureauReport_Create(requestPayload: CreditBureauReportCreateRequest): Observable<CreditBureauReportCreateResponse> {
        return this.http.post<CreditBureauReportCreateResponse>(CreditBureauReportCreate, requestPayload);
    }

    // Update
    CreditBureauReport_Update(requestPayload: CreditBureauReportUpdateRequest): Observable<CreditBureauReportUpdateResponse> {
        return this.http.post<CreditBureauReportUpdateResponse>(CreditBureauReportUpdate, requestPayload);
    }

    // Delete
    CreditBureauReport_Delete(requestPayload: CreditBureauReportDeleteRequest): Observable<void> {
        return this.http.post<void>(CreditBureauReportDelete, requestPayload);
    }

    // ReadAll
    CreditBureauReport_ReadAll(): Observable<CreditBureauReportReadAllResponse> {
        return this.http.get<CreditBureauReportReadAllResponse>(CreditBureauReportReadAll);
    }

    // ReadById
    CreditBureauReport_ReadById(requestPayload: CreditBureauReportReadByIdRequest): Observable<CreditBureauReportReadByIdResponse> {
        return this.http.post<CreditBureauReportReadByIdResponse>(CreditBureauReportReadById, requestPayload);
    }

    // ReadByUserId
    CreditBureauReport_ReadByUserId(requestPayload: CreditBureauReportReadByUserIdRequest): Observable<CreditBureauReportReadByUserIdResponse> {
        return this.http.post<CreditBureauReportReadByUserIdResponse>(CreditBureauReportReadByUserId, requestPayload);
    }

    //GetCreditBureauReportUI
    CreditBureauReport_GetCreditBureauReportUI(requestPayload: CreditBureauReportUIRequest): Observable<CreditBureauReportReadByUserIdResponse> {
        return this.http.post<CreditBureauReportReadByUserIdResponse>(GenerateBureauReportUI, requestPayload);
    }

    // *** CreditBureauSummary Services *** //

    // Create
    CreditBureauSummary_Create(requestPayload: CreditBureauSummaryCreateRequest): Observable<CreditBureauSummaryCreateResponse> {
        return this.http.post<CreditBureauSummaryCreateResponse>(CreditBureauSummaryCreate, requestPayload);
    }

    // Update
    CreditBureauSummary_Update(requestPayload: CreditBureauSummaryUpdateRequest): Observable<CreditBureauSummaryUpdateResponse> {
        return this.http.post<CreditBureauSummaryUpdateResponse>(CreditBureauSummaryUpdate, requestPayload);
    }

    // Delete
    CreditBureauSummary_Delete(requestPayload: CreditBureauSummaryDeleteRequest): Observable<void> {
        return this.http.post<void>(CreditBureauSummaryDelete, requestPayload);
    }

    // ReadAll
    CreditBureauSummary_ReadAll(): Observable<CreditBureauSummaryReadAllResponse> {
        return this.http.get<CreditBureauSummaryReadAllResponse>(CreditBureauSummaryReadAll);
    }

    // ReadById
    CreditBureauSummary_ReadById(requestPayload: CreditBureauSummaryReadByIdRequest): Observable<CreditBureauSummaryReadByIdResponse> {
        return this.http.post<CreditBureauSummaryReadByIdResponse>(CreditBureauSummaryReadById, requestPayload);
    }

    // ReadByUserId
    CreditBureauSummary_ReadByUserId(requestPayload: CreditBureauSummaryReadByUserIdRequest): Observable<CreditBureauSummaryReadByUserIdResponse> {
        return this.http.post<CreditBureauSummaryReadByUserIdResponse>(CreditBureauSummaryReadByUserId, requestPayload);
    }

    // ReadByBureauReportId
    CreditBureauSummary_ReadByBureauReportId(requestPayload: CreditBureauSummaryReadByBureauReportIdRequest): Observable<CreditBureauSummaryReadByBureauReportIdResponse> {
        return this.http.post<CreditBureauSummaryReadByBureauReportIdResponse>(CreditBureauSummaryReadByBureauReportId, requestPayload);
    }

    // *** ApplicationBureauMapping Services *** //

    // Create
    ApplicationBureauMapping_Create(requestPayload: ApplicationBureauMappingCreateRequest): Observable<ApplicationBureauMappingCreateResponse> {
        return this.http.post<ApplicationBureauMappingCreateResponse>(ApplicationBureauMappingCreate, requestPayload);
    }

    // Update
    ApplicationBureauMapping_Update(requestPayload: ApplicationBureauMappingUpdateRequest): Observable<ApplicationBureauMappingUpdateResponse> {
        return this.http.post<ApplicationBureauMappingUpdateResponse>(ApplicationBureauMappingUpdate, requestPayload);
    }

    // Delete
    ApplicationBureauMapping_Delete(requestPayload: ApplicationBureauMappingDeleteRequest): Observable<void> {
        return this.http.post<void>(ApplicationBureauMappingDelete, requestPayload);
    }

    // ReadAll
    ApplicationBureauMapping_ReadAll(): Observable<ApplicationBureauMappingReadAllResponse> {
        return this.http.get<ApplicationBureauMappingReadAllResponse>(ApplicationBureauMappingReadAll);
    }

    // ReadById
    ApplicationBureauMapping_ReadById(requestPayload: ApplicationBureauMappingReadByIdRequest): Observable<ApplicationBureauMappingReadByIdResponse> {
        return this.http.post<ApplicationBureauMappingReadByIdResponse>(ApplicationBureauMappingReadById, requestPayload);
    }

    // ReadByApplicationId
    ApplicationBureauMapping_ReadByApplicationId(requestPayload: ApplicationBureauMappingReadByApplicationIdRequest): Observable<ApplicationBureauMappingReadByApplicationIdResponse> {
        return this.http.post<ApplicationBureauMappingReadByApplicationIdResponse>(ApplicationBureauMappingReadByApplicationId, requestPayload);
    }

    // ReadByBureauSummaryId
    ApplicationBureauMapping_ReadByBureauSummaryId(requestPayload: ApplicationBureauMappingReadByBureauSummaryIdRequest): Observable<ApplicationBureauMappingReadByBureauSummaryIdResponse> {
        return this.http.post<ApplicationBureauMappingReadByBureauSummaryIdResponse>(ApplicationBureauMappingReadByBureauSummaryId, requestPayload);
    }

     // ----------------- Fraud Detection Services ------------------
    FraudDetectionDataFetch(requestPayload: FraudDetectionRequest):Observable<FraudDetectionResponse> {
        return this.http.post<FraudDetectionResponse>(FraudDetection, requestPayload)
    }

}